import { render, staticRenderFns } from "./NotificationMobile.vue?vue&type=template&id=171e1062&"
import script from "./NotificationMobile.vue?vue&type=script&lang=js&"
export * from "./NotificationMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports